module.exports = __webpack_public_path__ + "static/6-02bb8d379d7df7ecd31ba06d053f6f49.jpg";